import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { X, Search, ArrowUp, ArrowDown } from 'lucide-react';

interface EmployeeFiltersProps {
  statusFilter: string;
  searchQuery: string;
  departmentFilter: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  onStatusChange: (value: string) => void;
  onSearchChange: (value: string) => void;
  onDepartmentChange: (value: string) => void;
  onSortByChange: (value: string) => void;
  onSortOrderToggle: () => void;
  onClearFilters: () => void;
}

export const EmployeeFilters = ({
  statusFilter,
  searchQuery,
  departmentFilter,
  sortBy,
  sortOrder,
  onStatusChange,
  onSearchChange,
  onDepartmentChange,
  onSortByChange,
  onSortOrderToggle,
  onClearFilters
}: EmployeeFiltersProps) => {
  return (
    <div className="space-y-4 p-4 bg-muted/50 rounded-lg border">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold flex items-center gap-2">
          <Search className="h-4 w-4" />
          Filtres et recherche
        </h3>
        <Button variant="ghost" size="sm" onClick={onClearFilters}>
          <X className="h-4 w-4 mr-2" />
          Réinitialiser
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label>Statut</Label>
          <Select value={statusFilter} onValueChange={onStatusChange}>
            <SelectTrigger>
              <SelectValue placeholder="Tous" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous</SelectItem>
              <SelectItem value="active">Actif</SelectItem>
              <SelectItem value="inactive">Inactif</SelectItem>
              <SelectItem value="terminated">Terminé</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Département</Label>
          <Select value={departmentFilter} onValueChange={onDepartmentChange}>
            <SelectTrigger>
              <SelectValue placeholder="Tous" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tous</SelectItem>
              <SelectItem value="Opérations">Opérations</SelectItem>
              <SelectItem value="RH">Ressources Humaines</SelectItem>
              <SelectItem value="IT">Informatique</SelectItem>
              <SelectItem value="Finance">Finance</SelectItem>
              <SelectItem value="Marketing">Marketing</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Recherche</Label>
          <Input
            placeholder="Nom, email, poste..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label>Trier par</Label>
          <div className="flex gap-2">
            <Select value={sortBy} onValueChange={onSortByChange}>
              <SelectTrigger className="flex-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="created_at">Date de création</SelectItem>
                <SelectItem value="first_name">Prénom</SelectItem>
                <SelectItem value="last_name">Nom de famille</SelectItem>
                <SelectItem value="position">Poste</SelectItem>
                <SelectItem value="hire_date">Date d'embauche</SelectItem>
              </SelectContent>
            </Select>
            <Button
              variant="outline"
              size="icon"
              onClick={onSortOrderToggle}
            >
              {sortOrder === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
